import React from 'react';
import SubScoreTable from './SubScoreTable';
import HomeActivityLog from './HomeActivityLog';
import moment from 'moment';

export default function ParentLetter(props) {
  const {
    first_name: name,
    activityDate,
    subscores,
    includeActivityLog=false,
    t,
  } = props;

  const getUnderline = (length) => {
    return "".padStart(length, "_");
  }

  const date = moment(activityDate).format('M/D/YY');
  const interpolation = {escapeValue: false};

  return (
    <>
      <div className='page'>
        <p>{t("Dear")} {getUnderline(24)},</p>
        <p>{t("parent_letter_p1", {name, interpolation})} <a href="https://dyslexiaida.org/">https://dyslexiaida.org/</a>.</p>
        <p>{t("parent_letter_p2", {date, interpolation})}</p>
        <SubScoreTable subscores={subscores} t={t} />
      </div>
      <div className='page'>
        <p>{t("parent_letter_p3", {name, interpolation})}</p>
        {includeActivityLog && <p>{t("activity_log")}</p>}
        <p>{t("parent_letter_p4")}</p>
        <p>{t("parent_letter_p5")}</p>
        <p>{t("Sincerely")},</p>
      </div>
      {includeActivityLog && <HomeActivityLog t={t} />}
    </>
  );
}